import controller from './draggable-item-list-controller';

const DraggableItemListComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    items: '<',
    itemType: '<?',
    contextId: '<?',
    additionalText: '@?',
    selectedGroupListItem: '<',
    onGroupListItemSelect: '&?',
    onGroupListItemTrigger: '&?',
    onItemDragStart: '&?',
    onItemDragEnd: '&?',
  },
  template: `
    <div class="pill-list" >
      <div ng-if="ctrl.itemType == ctrl.ITEM_TYPE_DEFAULT || ctrl.itemType == ctrl.ITEM_TYPE_SIMPLE">
        <draggable-item
          class="pill"
          value="item"
          type="ctrl.itemType"
          additional-text="{{ctrl.additionalText}}"
          context-id="ctrl.contextId"
          selected="item === ctrl.selectedItem"
          on-select="ctrl.handleItemSelection($id)"
          on-drag-start="ctrl.handleItemDragStart($evt, $id)"
          on-drag-end="ctrl.handleItemDragEnd($evt, $id)"
          ng-repeat="item in ctrl.items" />
      </div>
      <div ng-if="ctrl.itemType == ctrl.ITEM_TYPE_DROPDOWN">
        <draggable-item
          class="pill"
          value="item"
          type="ctrl.itemType"
          additional-text="{{ctrl.additionalText}}"
          context-id="ctrl.contextId"
          selected="item === ctrl.selectedItem"
          on-drag-start="ctrl.handleItemDragStart($evt, $id)"
          on-drag-end="ctrl.handleItemDragEnd($evt, $id)"
          on-select="ctrl.handleItemSelection($id)"
          on-trigger="ctrl.handleItemTrigger($id)"
          ng-repeat="item in ctrl.items" />
        </div>
    </div>
  `,
};

export { DraggableItemListComponent };
